function backendUrl() {
  return process.env.REACT_APP_BACKEND_ENV;
}

export default backendUrl;
